import React from 'react'
import { ANALYTICS_EVENTS } from './events'
import TrackSurface from './TrackSurface'

export default function AnalyticsWidgetEvents({ subjectId, widgets = [] }) {
    // `subjectId` is the URL-derived id that drives the `key` on the analytics
    // screen wrapper (studentId / classId). Two guards, both needed:
    //  - `ready`: while it is null the screen has no subject yet, so skip.
    //  - `dedupeMs`: that id can mount 1-2x more while the query string settles;
    //    the short window collapses those into one emit, a real revisit later
    //    (seconds) still records once.
    const ready = !!subjectId && subjectId !== 'all'
    return (
        <>
            {widgets.map(({ key, label }) => (
                <TrackSurface
                    key={key}
                    event={ANALYTICS_EVENTS.ANALYTICS_WIDGET_VIEWED}
                    active={ready}
                    contentId={`${subjectId || 'all'}:${key}`}
                    content={label}
                    dedupeMs={1500}
                />
            ))}
        </>
    )
}
